import { render, staticRenderFns } from "./MultiContentCards.vue?vue&type=template&id=8778a924&scoped=true"
import script from "./MultiContentCards.vue?vue&type=script&lang=js"
export * from "./MultiContentCards.vue?vue&type=script&lang=js"
import style0 from "./MultiContentCards.vue?vue&type=style&index=0&id=8778a924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8778a924",
  null
  
)

export default component.exports